export default __webpack_public_path__ + "static/media/Copay.077e5627.svg";